import React from "react";
import Select, { components } from "react-select";
import { ReactComponent as SearchIcon } from "../../../../../assets/searchIcon.svg";
import useSelectStyles, { indicatorStyles } from "./themes";
type option = { label: string; value: string };
type Props = {
  label?: string;
  isMulti?: boolean;
  dir?: string;
  placeholder?: string;
  name: string;
  value?: option;
  isSearchable?: boolean;
  isAsync?: boolean;
  options?: option[];
  onChange: (val: any) => any;
};

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <SearchIcon />
    </components.DropdownIndicator>
  );
};

const PulseSelect = (props: Props) => {
  const classes = useSelectStyles();
  const { label, isSearchable } = props;

  return (
    <>
      {label !== (null || undefined) ? (
        <p className={classes.label}>{label}</p>
      ) : null}

      <Select
        styles={{
          indicatorsContainer: isSearchable ? indicatorStyles : undefined,
          indicatorSeparator: (base) => ({ ...base, display: "none" }),
          control: (base) => ({
            ...base,
            height: "43px",
            borderRadius: "6px",
            alignItems: "center",
            cursor: isSearchable ? "text" : "pointer",
          }),
        }}
        components={isSearchable ? { DropdownIndicator } : undefined}
        className={classes.select}
        {...props}
      />
    </>
  );
};

export default PulseSelect;
